export const environment = {
  production: false,
  apiUrl: 'https://api.careoregondev.integrio.dev'
};
